import {AppState} from '../states/app.state';
import {identity} from 'rxjs';
import {createSelector} from '@ngrx/store';


export class ProduktDialogSelectors {

  /**
   * Die `select`-Eigenschaft ist ein Objekt, das Funktionen definiert, jede Funktion selektiert eine
   * bestimmte Eigenschaft aus dem State.
   * Das sind grundlegende Selektoren, die im ganzen Projekt als Bausteine für komplexere Selektoren wiederverwendet
   * werden können.
   */
  private static select = {
    isOpen: (state: AppState) => state.produktDialog.isOpen,
    produkt: (state: AppState) => state.produktDialog.produkt,
    addToBeleg: (state: AppState) => state.produktDialog.addToBeleg,
    mengeneinheiten: (state: AppState) => state.produktDialog.mengeneinheiten,
    mengeneinheitenFilter: (state: AppState) => state.produktDialog.mengeneinheitenFilter,
  };

  public static isOpen = createSelector(
    this.select.isOpen,
    identity,
  );

  public static produkt = createSelector(
    this.select.produkt,
    identity,
  );

  public static addToBeleg = createSelector(
    this.select.addToBeleg,
    identity,
  );

  public static getFilteredMengeneinheiten = createSelector(
    this.select.mengeneinheiten,
    this.select.mengeneinheitenFilter,
    (mengeneinheiten, mengeneinheitenFilter) => {
      return mengeneinheiten.filter(mengeneinheit => mengeneinheit.bezeichnung.toLowerCase().includes(mengeneinheitenFilter.toLowerCase()));
    }
  );
}
